<template>
    <div id="level-form">
        <v-card v-for="kelas in kelasList" :key="kelas" flat>
            <!-- Kelas Header -->
            <v-card-actions>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">Kelas</v-list-item-title>
                        <v-text-field :value="kelas" outlined disabled filled />
                    </v-list-item-content>
                </v-list-item>
                <v-spacer></v-spacer>
                <v-btn icon @click="expanded[kelas] = !expanded[kelas]">
                    <v-icon>{{ expanded[kelas] ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
            </v-card-actions>

            <!-- Expandable Section -->
            <v-expand-transition>
                <div v-show="expanded[kelas]" class="mx-5">
                    <div v-for="(lvl, idx) in levelTemplate" :key="idx">
                        <v-divider class="my-4" />

                        <!-- Level Name -->
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title class="font-weight-bold pb-2">Level</v-list-item-title>
                                <v-text-field :value="lvl.value" outlined disabled filled />
                            </v-list-item-content>
                        </v-list-item>

                        <!-- Min & Max Poin -->
                        <v-list-item>
                            <v-row>
                                <v-col>
                                    <v-list-item two-line class="pa-0">
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title class="font-weight-bold pb-2">Minimal
                                                Poin</v-list-item-title>
                                            <v-text-field v-model="lvl.min_poin" outlined />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col>
                                    <v-list-item two-line class="pa-0">
                                        <v-list-item-content class="pa-0">
                                            <v-list-item-title class="font-weight-bold pb-2">Maksimal
                                                Poin</v-list-item-title>
                                            <v-text-field v-model="lvl.max_poin" outlined />
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </div>

                    <!-- Save Button -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="submit(kelas)">
                            Simpan Level Kelas {{ kelas }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-expand-transition>
        </v-card>

        <!-- Bottom Navigation -->
        <v-card-actions class="mt-5">
            <v-spacer></v-spacer>
            <v-btn @click="$emit('uncompleted')" depressed text>Kembali</v-btn>
            <v-btn color="blue" type="button" class="btn btn-success pull-right" @click="$emit('completed')" depressed
                dark>
                Selesai
            </v-btn>
        </v-card-actions>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
  name: "level-form",
  components: { "app-spinner": Spinner },

  data() {
    return {
      isLoading: false,
      expanded: {},
      periode_id: this.$route.query.id,
      kelasList: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      levelTemplate: [
        { id: 1, level_id: 0, value: "No Rank", min_poin: 1, max_poin: 0 },
        { id: 2, level_id: 0, value: "Beginner", min_poin: 0, max_poin: 0 },
        { id: 3, level_id: 0, value: "Silver", min_poin: 0, max_poin: 0 },
        { id: 4, level_id: 0, value: "Bronze", min_poin: 0, max_poin: 0 },
        { id: 5, level_id: 0, value: "Gold", min_poin: 0, max_poin: 99000 }
      ]
    };
  },

  created() {
    this.kelasList.forEach(k => this.$set(this.expanded, k, false));
  },

  mounted() {
    if (this.$route.query.id) this.getDetailLevel();
  },

  methods: {
    async getDetailLevel() {
      this.isLoading = true;
      await AmbisMeterService.getLevelDetail(this.$route.query.id, (response) => {
        if (response.success) {
          response.data.forEach((result) => {
            const level = this.levelTemplate.find(l => l.id === result.level_id);
            if (level) {
              level.level_id = result.id;
              level.min_poin = result.min_poin;
              level.max_poin = result.max_poin;
            }
          });
        }
        this.isLoading = false;
      });
    },

    submit(kelas) {
      const arrayLevel = this.levelTemplate.map(l => ({
        id: l.level_id,
        periode_id: this.$store.state.ambismeter.id,
        kelas,
        level_id: l.id,
        min_poin: parseFloat(l.min_poin),
        max_poin: parseFloat(l.max_poin)
      }));

      this.isLoading = true;
      if (!this.$route.query.id) {
        AmbisMeterService.addLevel(arrayLevel, (result) => {
          this.$store.commit("showAlert", {
            message: result.success
              ? `Level Kelas ${kelas} telah berhasil disimpan!`
              : `Gagal menyimpan level!`,
            type: result.success ? "success" : "error"
          });
          this.isLoading = false;
        });
      } else {
        AmbisMeterService.updateLevel(this.$route.query.id, kelas, arrayLevel, (result) => {
          this.$store.commit("showAlert", {
            message: result.success
              ? `Level Kelas ${kelas} telah berhasil diubah!`
              : `Gagal update level!`,
            type: result.success ? "success" : "error"
          });
          this.isLoading = false;
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// LevelForm.vue?495c5aa2